import { InsertRowLeftOutlined, UndoOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { getRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import PlusSquareOutlined from "../../image/PlusSquareOutlined.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import { ReactComponent as ArchiveButtonicon } from "../../image/ArchiveButtonicon.svg";

import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";

const WarehouseList = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getcompanyList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("warehouse/", state);

        if (apiResponse?.data?.results?.success) {
          setCompanyList(apiResponse?.data?.results?.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_warehouse_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getcompanyList();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    // if (sortField === "company_name" && sortOrder === "ascend") {
    //   sortingEnumKey = "company_name";
    // }
    // if (sortField === "company_name" && sortOrder === "descend") {
    //   sortingEnumKey = "-company_name";
    // }
    // if (sortField === "company_email" && sortOrder === "ascend") {
    //   sortingEnumKey = "company_email";
    // }
    // if (sortField === "company_email" && sortOrder === "descend") {
    //   sortingEnumKey = "-company_email";
    // }

    if (sortField === "street_address" && sortOrder === "ascend") {
      sortingEnumKey = "street_address";
    }
    if (sortField === "street_address" && sortOrder === "descend") {
      sortingEnumKey = "-street_address";
    }

    if (sortField === "additional_details" && sortOrder === "ascend") {
      sortingEnumKey = "additional_details";
    }
    if (sortField === "additional_details" && sortOrder === "descend") {
      sortingEnumKey = "-additional_details";
    }

    if (sortField === "suburb" && sortOrder === "ascend") {
      sortingEnumKey = "suburb";
    }
    if (sortField === "suburb" && sortOrder === "descend") {
      sortingEnumKey = "-suburb";
    }

    if (sortField === "state" && sortOrder === "ascend") {
      sortingEnumKey = "state";
    }
    if (sortField === "state" && sortOrder === "descend") {
      sortingEnumKey = "-state";
    }
    if (sortField === "postcode" && sortOrder === "ascend") {
      sortingEnumKey = "postcode";
    }
    if (sortField === "postcode" && sortOrder === "descend") {
      sortingEnumKey = "-postcode";
    }

    return sortingEnumKey;
  };

  const [checkedList, setCheckedList] = useState([
    "street_address",
    "additional_details",
    "suburb",
    "state",
    "postcode",
    "operation",
  ]);
  const [columns, setColumns] = useState([
    {
      title: "Address",
      dataIndex: "street_address",
      key: "street_address",
      sorter: true,
      width: 130,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
        // </Tooltip>
      ),
    },
    {
      title: "Additional Details",
      dataIndex: "additional_details",
      key: "additional_details",
      sorter: true,
      width: 130,
    },
    {
      title: "Suburb",
      dataIndex: "suburb",
      key: "suburb",
      sorter: true,
      width: 130,
      render: (dataIndex) => (
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
      ),
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      sorter: true,
      width: 130,
    },

    {
      title: "Postcode",
      dataIndex: "postcode",
      key: "postcode",
      sorter: true,
      width: 130,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
        // </Tooltip>
      ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (text, record) => (
        <Space>
          {/* <Tooltip
            color={colors}
            placement="left"
            title={<span style={{ color: "#fff" }}>Edit</span>}
          > */}
            <Link
              to={{
                pathname: "/warehouse/edit/" + btoa(record.id),
              }}
            >
              <Editicon onClick={() => handleEdit(record.id)} />
            </Link>
          {/* </Tooltip> */}
          {/* <Tooltip
            color={colors}
            placement="right"
            title={<span style={{ color: "#fff" }}>Archive</span>}
          > */}
            <Popconfirm
              className="action"
              title={t("pop_title")}
              okText={t("pop_ok")}
              cancelText={t("pop_cancel")}
              onConfirm={() => handleArchive(record.id)}
            >
              <Archive style={{ cursor: "pointer" }} />
            </Popconfirm>
          {/* </Tooltip> */}
        </Space>
      ),
    },
  ]);

  useEffect(() => {
    const updatedColumns = columns.map((column) => ({
      ...column,
      hidden: !checkedList.includes(column.key),
    }));
    setColumns(updatedColumns);
  }, [checkedList, columns]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  const columnMenu = (
    <Menu>
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            <Col span={12}>
              <Checkbox value="street_address">Address</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="additional_details">Additional Details</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="suburb">Suburb</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="state">State</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="postcode">Postcode</Checkbox>
            </Col>

            <Col span={12}>
              <Checkbox value="operation" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const handleArchive = async (id = []) => {
    // let ids = selectedRow;
    // if (ids.length === 0) {
    //   ids.push(id);
    // }
    let ids = [...selectedRow];

    if (ids.length === 0 && id) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("warehouse/archive-warehouse/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids.length;

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("warehouse_archive_successfully"));

        setSelectedRow([]);
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };

  const handleEdit = (id) => {};

  const colors = ["#737373"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View & manage the list of company within the organization.
                </span>
              }
            > */}
              <h3>{t("Manage WareHouse")}</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Manage WareHouse")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      // value={state.search}
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
                <Button
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  onClick={() => handleReset()}
                >
                  <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} /> Reset
                  </span>
                </Button>
              // </Tooltip>
            ) : (
              ""
            )}
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Add A New Company To The Organization&apos;s Database.
                </span>
              }
            > */}
              <Button
                className="BlueShadowBtn"
                type="primary"
                onClick={() => navigate("/warehouse/add")}
                icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
              >
                {t("Add WareHouse")}
              </Button>
            {/* </Tooltip> */}

            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >
                <ButtonField
                      className="BlueShadowBtn"
                      type="primary"
                      htmlType="button"
                      label={
                        <>
                          <div
                            className="BlueShadowBtn"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <ArchiveButtonicon />
                            <span>{t("pl_archive")}</span>
                          </div>
                        </>
                      }
                    />
              </Popconfirm>
            )}
            {/* <Tooltip placement="topLeft" title="View Archived Records"> */}
              <Link className="Archiveicon" to="/warehouse/archive">
                <Archiveicon />
              </Link>
            {/* </Tooltip> */}
            {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
              <div className="gridiconswrap">
                <Dropdown
                  overlay={columnMenu}
                  trigger={["click"]}
                  placement="bottomRight"
                  visible={dropdownVisible}
                  onVisibleChange={(visible) => setDropdownVisible(visible)}
                >
                  <Button
                    type="primary"
                    shape="circle"
                    icon={<InsertRowLeftOutlined />}
                    onClick={() => setDropdownVisible(!dropdownVisible)}
                  />
                </Dropdown>
              </div>
            {/* </Tooltip> */}
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="PR-body">
          <Table
            rowSelection={rowSelection}
            columns={columns.filter((col) => !col.hidden)}
            rowKey={(record) => record.id}
            dataSource={companyList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            onChange={handleTableChange}
            scroll={{
              x: 1000,
            }}
          />
        </div>
      </section>
    </>
  );
};
export default WarehouseList;
